import { useFormik } from "formik";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "../../../components/buttons/button";
import { TextInput } from "../../../components/inputs/textInput";
import { InfoComponent } from "../../../components/notification/infoComponent";
import { AuthHeader } from "../../../components/typography/authHeader";
import { useResetPasswordMutation } from "../../../redux/features/auth/auth.api";
import { BaseApiErrorResponse } from "../../../utils/types";
import { ResetPasswordSchema } from "../../../utils/validations";

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const [resetPassword, { isLoading, isError, error }] =
    useResetPasswordMutation();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues: {
        password: "",
        confirmPassword: "",
      },
      validationSchema: ResetPasswordSchema,
      onSubmit: async (values) => {
        const response = await resetPassword({
          email: searchParams.get("email") ?? "",
          password: values.password,
        });

        if (response.data?.status === "success") {
          toast.success("You just reset your password");
          navigate("/login");
        }
      },
    });

  useEffect(() => {
    if (!searchParams.get("email")) {
      navigate("/login");
    }
    // eslint-disable-next-line
  }, [searchParams]);
  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <AuthHeader
        header="Create New Password"
        text="Your password must be at least 8 characters"
      />

      <div className="mt-10 flex flex-col gap-5">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}

        <TextInput
          type="password"
          name="password"
          value={values.password}
          placeholder="Enter New Password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Enter New Password"
          errors={errors.password && touched.password ? errors.password : ""}
          autoFocus
        />

        <TextInput
          type="password"
          name="confirmPassword"
          value={values.confirmPassword}
          placeholder="Confirm Password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Confirm Password"
          errors={
            errors.confirmPassword && touched.confirmPassword
              ? errors.confirmPassword
              : ""
          }
        />

        <Button
          type="submit"
          text="Update Password"
          variation="primary"
          className="mt-5"
          loading={isLoading}
          disabled={isLoading}
        />
      </div>
    </form>
  );
};
